export default {
  navigationBarTitleText: "全部项目",
};
